export const normalizeName = (name) => {
  return (name || '').trim().toLowerCase();
};
